import { createSelector, createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'date',
  initialState: {
    dateFrom: '',
    dateTO: '',
    loading: false,
    list: [],
    intervalId: '',
    deviceId: '',
  },
  reducers: {
    DateFrom: (date, action) => {
      date.dateFrom = action.payload
    },
    DateTO: (date, action) => {
      date.dateTO = action.payload
    },
    IdInterval: (date, action) => {
      date.intervalId = action.payload.intervalId
      date.deviceId = action.payload.deviceId
    },

    resetDate: (date, action) => {
      date.dateFrom = action.payload
      date.dateTO = action.payload
    },
  },
})

export const setResetDate = (payload: string) => (dispatch: any) => {
  dispatch({
    type: slice.actions.resetDate.type,
    payload,
  })
}
export const setDateFrom = (date: string) => (dispatch: any) => {
  dispatch({
    type: slice.actions.DateFrom.type,
    payload: date,
  })
}

export const setDateTo = (date: string) => (dispatch: any) => {
  dispatch({
    type: slice.actions.DateTO.type,
    payload: date,
  })
}
export const setIdInterval = (payload: object) => (dispatch: any) => {
  dispatch({
    type: slice.actions.IdInterval.type,
    payload,
  })
}

export const getDateFrom = createSelector(
  (state: any) => state.date,
  (date: any) => date.dateFrom,
)

export const getDateTo = createSelector(
  (state: any) => state.date,
  (date: any) => date.dateTO,
)

export const getIdInterval = createSelector(
  (state: any) => state.date,
  (date: any) => date.intervalId,
)
export const getDeviceId = createSelector(
  (state: any) => state.date,
  (date: any) => date.deviceId,
)

export default slice.reducer
